// extracted by mini-css-extract-plugin
export var drawerContent = "_30-0";
export var valueBlock = "_30-1";
export var valueBlockFrom = "_30-2 _30-1";
export var valueBlockTo = "_30-3 _30-1";